import { Col } from "antd";
import { Select, Typography } from "antd";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { setRecordingDetail } from "../../slices/recordingsSlice";
import { LC_KEYS } from "../../utils/constants";
import styles from "./createnotemodal.module.scss";

const LocationSelector = ({ fullWidth = false }: { fullWidth?: boolean }) => {
  const componentName = "createnotemodal";
  const dispatch = useAppDispatch();

  const { recordingDetail } = useAppSelector((state) => state.recordings);
  return (
    <Col span={fullWidth ? 24 : 12} className={`${styles[`${componentName}__modal-row`]}`}>
      <Typography.Text>Location: (optional)</Typography.Text>
      <Select
        value={recordingDetail?.location_type}
        placeholder="Select Location"
        className={`${styles[`${componentName}__modal-row-field`]}`}
        onChange={(value) => {
          localStorage.setItem(LC_KEYS.LOCATION_TYPE, value.toString());
          dispatch(
            setRecordingDetail({
              ...recordingDetail,
              location_type: typeof value === "number" ? value : undefined,
            }),
          );
        }}
      >
        <Select.Option value={""}>---</Select.Option>
        <Select.Option value={0}>Telehealth</Select.Option>
        <Select.Option value={1}>In-person</Select.Option>
      </Select>
    </Col>
  );
};

export default LocationSelector;
